// extracted by mini-css-extract-plugin
export default {"Form":"Registration_Form__Kb9XR"};